import * as React from 'react';
import { Flex } from '../../Flex';
import { Button } from '@/hen-ui/atomics/Button';
import { Image } from '@/hen-ui/atomics/Image';
import type { ComparisonItem } from '../types';

export const ComparisonItemImage: React.FC<{ item: ComparisonItem }> = ({
  item,
}) => {
  return (
    <Flex
      className='relative w-28 h-16 bg-white border border-neutral-200 rounded-xs p-2'
      direction='column'
    >
      <Image src={item.header.image.src} alt={item.header.image.alt} />
      {item.header.remove && (
        <Button
          type='button'
          aria-label={item.header.remove.ariaLabel ?? 'Remove item'}
          onClick={item.header.remove.onClick}
          variant='textOnly'
          size='sm'
          iconBefore={item.header.remove.icon ?? 'x'}
          className='absolute -top-3 -right-3 h-6 w-6 rounded-full bg-white focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-2'
        />
      )}
    </Flex>
  );
};

ComparisonItemImage.displayName = 'ComparisonItemImage';
